function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Love",
  className: "cls-1",
  d: "M10.032.771h0A3.819,3.819,0,0,0,6.97,2.428,3.817,3.817,0,0,0,3.912.77h0A4.169,4.169,0,0,0-.028,4.99v.07a.965.965,0,0,0,0,.17c.19,5.67,7,8,7,8s6.807-2.33,7-8a1.206,1.206,0,0,0,0-.17V4.99A4.17,4.17,0,0,0,10.032.771Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/love.75bb4132.svg";
export { SvgComponent as ReactComponent };